import type { schemaType as detailSchemaType } from '~~/shared/api/rurality/v3/cottage-deals/cottage/detail/schema'
import type { propsInterface } from '~~/modules/design-system/sections/s-deals.vue'

export const useToSDeals = () => {
  const fromRuralityCottageDealsDetail = (params: {
    dataIn: detailSchemaType
    province: string
    slug: string
  }): propsInterface => {
    let items: propsInterface['items'] = []

    items = params.dataIn.deals.map(item => {
      const itemMapped: propsInterface['items'][0] = {
        title: item.title,

        description: item.description,

        percentage: Math.round(item.percentage),
        whatIncludes: item.whatIncludes,
        total: toEuro(item.total.amount),
        totalOld: toEuro(item.totalOld.amount),

        dateIn: toRuralityDate().legacyDate(item.dateIn),
        dateOut: toRuralityDate().legacyDate(item.dateOut),

        nights: item.nights,
        people: item.people,
        pricePersonNight: toEuro(item.pricePersonNight.amount),

        slug: params.slug,
        province: params.province,
        id: item.id,
        rentUnitId: item.rentUnitId,
      }

      return itemMapped
    })

    return { items }
  }

  return {
    fromRuralityCottageDealsDetail,
  }
}
